import { IconButton } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../../assets/LOGO_FID_HORIZONTAL.jpg";


const LogoFid = ({largeur=180}) => {
  return (
    <IconButton
    edge="start"
    color="inherit"
    aria-label="open drawer"
    sx={{ mr: 2, "&:hover": { backgroundColor: "transparent" } }}
    component={Link}
    to={"/"}
  >
    <img src={logo} alt="Fonds d'Intervenetion pour le Developpement" width={largeur}/>
  </IconButton>
  )
}

export default LogoFid